import './nuova-autenticazione-link.scss';
import React from 'react';
import {Link} from 'react-router-dom';
import {ROUTES} from '../../constant/constant';

function NuovaAutenticazioneLink() {
  return (
    <p className="NuovaAutenticazioneLink">
      <Link to={ROUTES.HOME} >Effettua una nuova autenticazione</Link>
    </p>
  );
}

export default NuovaAutenticazioneLink;
